import React from 'react';
import { withRouter } from 'react-router-dom';
import ReactGA from 'react-ga';
import { connect } from 'react-redux';

// Check for a valid key
const useGoogleAnayltics = process.env.REACT_APP_GoogleAnalyticsKey || process.env.REACT_APP_GoogleAnalyticsKey_Agent;

// handles route changes
class GoogleAnalytics extends React.Component {
    constructor(props) {
        super(props);

        // create a listener to log page views
        this.props.history.listen((location, action) => {
            this.logPageView(location.pathname);
        });
    }

    componentWillReceiveProps(nextProps) {
        const { isRealtor, userName } = nextProps;

        // If isRealtor didn't change no need to re-initialize
        if (isRealtor === this.props.isRealtor) return;

        var gaKey = null;

        // Select key based on audience
        if (isRealtor === true)
            gaKey = process.env.REACT_APP_GoogleAnalyticsKey_Agent;
        else if (isRealtor === false)
            gaKey = process.env.REACT_APP_GoogleAnalyticsKey;


        var Initialized = null;
        if (this.state !== null && this.state.Initialized !== null)
            Initialized = true;

        // Remove GA if userName is null
        if (Initialized && !userName)
        {
            ReactGA.ga('remove');
            this.setState({Initialized: null});
        }

        // Initalize if there is a key and its not already initalized
        if (Initialized === null && gaKey)
        {
            console.log('GA Analytics initialized');
            ReactGA.initialize(gaKey, {debug: false });

            ReactGA.set({ userId: userName });

            // Log the initial page load
            ReactGA.pageview(this.props.location.pathname);
            
            this.setState({Initialized: true});
        }
        else if (gaKey)
        {
            // Update username
            ReactGA.set({ userId: userName });
        }

    }

    logPageView = (pathName) => {
        // Ignore login and landing page
        if (pathName.includes('/login') || pathName === "/")
            return;
        
        // Check if initialized
        if (!this.state || !this.state.Initialized)
            return;

        if (useGoogleAnayltics)
            ReactGA.pageview(pathName);
    }

    render() {
        return null;
    }
}

const mapStateToProps = (state, props) => {
    return {
        isRealtor: state.profile.mine == null ? null : state.profile.mine.Realtor,
        userName: state.profile.mine == null ? null : state.profile.mine.Username
    }
}

export default withRouter(connect(mapStateToProps)(GoogleAnalytics));

// handles tab clicks
export const pageView = (pathname) => {
    if (useGoogleAnayltics)
        ReactGA.pageview(pathname);
}

// Handle Modal opens
export const modalView = (pathname) => {
    if (useGoogleAnayltics)
        ReactGA.modalview(pathname);
}

// Handle Events
export const eventView = (category, action, value) => {
    if (useGoogleAnayltics)
        ReactGA.event({
            category: category,
            action: action,
            value: value
        });
}


